// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-O1":"O1_outdoor-recreation-O1__MkEZu"};